/**
 * ROUND_END — round results, banker rotation, no input.
 *
 * Used by cee-lo between the last shooter's roll and the next round's
 * STARTING countdown. Craps no longer enters this phase in the
 * collapsed flow (terminal rolls go straight to SHOOTER_SET_STACK),
 * but the state is registered defensively for stray transitions.
 *
 * Dice from the just-completed roll stay where they landed — STARTING's
 * onExit clears them when the next round actually begins. No dice
 * cleanup here.
 *
 * The dice-result icons on profile cards arrived via the post-roll
 * flyout in PLAYER_ROLL.onExit; they persist into ROUND_END naturally
 * via the overlay's display cache. Late joiners (animated:false on the
 * first update) get the icons placed instantly via _checkPlayers.
 */

import type { GameUpdate } from '@sdl/shared';
import { State } from '../State.js';

export class RoundEndState extends State {
  async onEnter(update: GameUpdate): Promise<void> {
    const game = this.game;

    game.playerProfilesOverlay?.show();
    game.playerProfilesOverlay?.setMode('shooting');
    game.instructionBanner?.hide();
    game.countdownOverlay?.stop();
    game.bettingHUD3D?.setLockInVisible(false);
    game.cameraController?.setMode('default');

    this._updateProfiles(update);
    await this._checkPlayers(update);
  }

  async onUpdate(update: GameUpdate): Promise<void> {
    this._updateProfiles(update);
    await this._checkPlayers(update);
  }

  // No onExit — dice stay on the table until STARTING clears them
  // before the next round, and there's no ROUND_END-specific UI to
  // tear down.
}
